import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getBatchLoanRequestStatus = async ({
  Page,
  PageSize,
  BatchNumber,
  FromDate,
  ToDate,
  AggregatorId,
  Status,
}) => {
  let queryParams = `?Page=${Page}&PageSize=${PageSize}`;
  if (BatchNumber) {
    queryParams = `${queryParams}&BatchNumber=${BatchNumber}`;
  }
  if (AggregatorId) {
    queryParams = `${queryParams}&AggregatorId=${AggregatorId}`;
  }
  if (FromDate && ToDate) {
    queryParams = `${queryParams}&FromDate=${FromDate}&ToDate=${ToDate}`;
  }
  if (Status) {
    queryParams = `${queryParams}&Status=${Status}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.BATCH_LOAN_REQUEST_STATUS}${queryParams}`
  );
  return data;
};

export default function useBatchLoanRequestStatus({
  Page,
  PageSize,
  BatchNumber,
  FromDate,
  ToDate,
  AggregatorId,
  Status,
}) {
  return useQuery(
    [
      { Page, PageSize, BatchNumber, FromDate, ToDate, AggregatorId, Status },
      "getBatchLoanRequestStatus",
    ],
    getBatchLoanRequestStatus,
    {
      refetchOnWindowFocus: false,
    }
  );
}
